export default "__VITE_ASSET__$jp3w_O3__"